module.exports = __webpack_public_path__ + "img/pic1.6b7074d2.png";